import { api } from "../api";
import { downloadSurfaceQuery } from "./downloadSurface";
import { toastSuccess, toastError } from "../ui/messages";

import { getDomElement, setHtml, fadeIn, setText } from "../utils/dom";
import { config } from "../config";
import { SERVER_BASE_URL } from "../lib/server";

export async function ptDlDo(id: string): Promise<void> {
  if (parseInt(id) > 0) {
    try {
      // Trigger the file download directly via iframe — /ptdlfile handles
      // both inventory registration and serving the file
      setHtml(
        "frametarget",
        // The surface travels in the URL: this is a navigation, not a fetch, so there is no
        // body to carry it. See features/downloadSurface.ts.
        `<iframe src="${SERVER_BASE_URL}/ptdlfile?id=${encodeURIComponent(id)}${downloadSurfaceQuery(id)}"></iframe>`
      );

      toastSuccess("Download started");
      setHtml(
        `view-download-buttons-${id}`,
        '<span style="font-size: 0.7em; font-weight: 400;"><i>Artwork downloaded</i></span>'
      );

      if (!config.isAdmin) {
        fadeIn("quick-downloader");
      }

      const qdlcount = parseInt(getDomElement("quick-downloader-count")?.innerHTML ?? "0") + 1;
      setText("quick-downloader-count", String(qdlcount));

      if (qdlcount === 1) {
        setText("quick-downloader-s", "");
      } else {
        setText("quick-downloader-s", "s");
      }
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Download failed";
      toastError(msg);
    }
  } else {
    toastError("Not a valid Artwork ID");
  }
}

export async function dlDo(id: string): Promise<void> {
  if (parseInt(id) > 0) {
    try {
      const response = await api.downloadCart.dlDo({ id: parseInt(id) });
      toastSuccess("Download started");
      setHtml("frametarget", `<iframe src="${response.url}"></iframe>`);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : "Download failed";
      toastError(msg);
    }
  } else {
    toastError("Not a valid Artwork ID");
  }
}

export async function savedlsettings(): Promise<void> {
  const interiors = getDomElement<HTMLInputElement>("dl_interiors")?.checked ?? false;
  // The resolution radios are not rendered for the browser downloader, which cannot resize.
  // Reading a missing radio as "not checked" would have posted `res: 1` and rewritten a
  // member's stored custom size to Max every time they touched the interiors box, so the
  // field is OMITTED when the control is absent and the server leaves the column alone.
  const resEl = getDomElement<HTMLInputElement>("dl_res_2");

  // The enhanced downloader's own control, present only when that downloader is active. Same
  // rule as `res`: send it when it is on the page, omit it when it is not, so neither
  // downloader's stored choice is rewritten by a change to the other's.
  const rendition = getDomElement<HTMLInputElement>("dl_rend_medium")?.checked
    ? "MEDIUM"
    : getDomElement<HTMLInputElement>("dl_rend_low")?.checked
      ? "LOW"
      : getDomElement<HTMLInputElement>("dl_rend_original")
        ? "ORIGINAL"
        : undefined;

  try {
    await api.reseller.setDlSettings({
      interiors,
      ...(resEl ? { res: resEl.checked ? 2 : 1 } : {}),
      ...(rendition ? { rendition } : {}),
    });
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}
